import { AddressFields } from '../../pages/account-info/models/form-models';
import { UnitedStatesISOCountryCode } from '../../pages/arc/constants/constant-strings';
import { documentUploadRequiredChangeFields } from '../constants/lists';
import { Person } from '../models/person-model';

const taxId = 'tax_id';
const dob = 'date_of_birth';
const gender = 'gender';

export function requiredDocUploadFieldChanged(toUpdate: any, initialValues: any, skipDocUpload = false) {
	if (!toUpdate || skipDocUpload) return false;

	return Object.keys(toUpdate).some(updatedKey => {
		// if tax_id is removed, don't trigger doc upload
		if (updatedKey === taxId && !toUpdate[updatedKey]) return false;
		if (!initialValues[updatedKey] && 
			(updatedKey === taxId || updatedKey === dob || updatedKey === gender)) {
			return false;
		}

		return documentUploadRequiredChangeFields.includes(updatedKey);
	});
}


function IsCurrentPersonAddressUS(values: any, addressFieldNames: AddressFields){
	if (!addressFieldNames) return false;
	
	const personCountryCode = values[addressFieldNames.country as string];
	return personCountryCode === UnitedStatesISOCountryCode;
}

function IsCurrentPersonAddressInternational(values: any, addressFieldNames: AddressFields){	
	return !IsCurrentPersonAddressUS(values, addressFieldNames);
}

function HasAddressChanged(currentPerson: Person, values: any, addressFieldNames: AddressFields){
	if (!addressFieldNames) return false;

	const currentCountry = values[addressFieldNames.country as string];
	const currentAddress1 = values[addressFieldNames.address1 as string];
	const currentAddress2 = values[addressFieldNames.address2 as string];
	const currentAddress3 = values[addressFieldNames.address3 as string];
	const currentCity = values[addressFieldNames.city as string];
	const currentState = values[addressFieldNames.state as string];	
	const currentPostalCode = values[addressFieldNames.postalCode as string];

	const countryChanged = currentCountry && currentPerson.mailing_country !== currentCountry;
	const postalCodeChanged = currentCountry && currentPerson.mailing_postal_code !== currentPostalCode;

	const address1Changed = (currentAddress1 && currentPerson.mailing_address_1 !== currentAddress1) ||
							(currentPerson.mailing_address_1 && currentPerson.mailing_address_1 !== currentAddress1);
	const address2Changed = (currentAddress2 && currentPerson.mailing_address_2 !== currentAddress2) ||
							(currentPerson.mailing_address_2 && currentPerson.mailing_address_2 !== currentAddress2);
	const address3Changed = (currentAddress3 && currentPerson.mailing_address_3 !== currentAddress3) ||
							(currentPerson.mailing_address_3 && currentPerson.mailing_address_3 !== currentAddress3);

	const cityChanged = currentCity && currentPerson.mailing_city !== currentCity;
	const stateChanged = currentState && currentPerson.mailing_state !== currentState;	

	return countryChanged || stateChanged || cityChanged || postalCodeChanged ||
	address1Changed || address2Changed || address3Changed;
}

export function InternationalAddressWarning(currentPerson: Person, values: any, addressFieldNames: AddressFields, isReceivingPensionOrPayout: boolean) {
	if (!addressFieldNames || !isReceivingPensionOrPayout) return false;
	
	const currentAddressInternational = IsCurrentPersonAddressInternational(currentPerson, addressFieldNames);	
	const newAddressInternational = IsCurrentPersonAddressInternational(values, addressFieldNames);	
	
	const addressChanged = HasAddressChanged(currentPerson, values, addressFieldNames);

	return ((newAddressInternational || (newAddressInternational !== currentAddressInternational)) && addressChanged);
}

export function shouldShowDocUpload(currentPerson: Person, fieldName: string, value: any) {
	if (!currentPerson || currentPerson[fieldName] === undefined) return false;

	if (fieldName === 'masked_date_of_birth' && !value?.toLowerCase()?.includes('x')) { return true; }
	return currentPerson[fieldName] !== value;
}